// extracted by mini-css-extract-plugin
export var lg = "_k5-7";
export var md = "_k5-6";
export var placeholderContainer = "_k5-1";
export var placeholderIcon = "_k5-2";
export var productImage = "_k5-0";
export var sm = "_k5-5";
export var xl = "_k5-8";
export var xs = "_k5-4";
export var xxs = "_k5-3";